var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckInsBadgeColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 163.1 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient--check-ins",
    x1: 3.07,
    y1: -265.82,
    x2: 29.68,
    y2: -292.42,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -262.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a76ebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#875e96"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check-ins-badge-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M79.9,8.2a7.8,7.8,0,0,0-7.7,7.7v.4c0,4.4,3.1,8.1,7.8,8.1a9.1,9.1,0,0,0,5.7-1.9c.5-.4.3-.7.1-1.1L84.9,20c-.3-.4-.6-.3-1,0a6.2,6.2,0,0,1-3.7,1.3,4.5,4.5,0,0,1-4.6-4.2H86.2a.7.7,0,0,0,.7-.7,4.1,4.1,0,0,0,.1-1.1,7,7,0,0,0-6.7-7.1Zm-4.2,6.4a3.9,3.9,0,0,1,4.2-3.5,3.6,3.6,0,0,1,3.8,3.5h-8Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.7,14.8c-1.6-.7-2.7-1.3-2.7-2.3s.7-1.4,2-1.4a7.6,7.6,0,0,1,3.3.8.7.7,0,0,0,1-.3h0l.5-1.1a.8.8,0,0,0-.3-1.1A8.9,8.9,0,0,0,157,8.2c-3.8,0-5.1,2.3-5.1,4.2s1.8,3.9,4.2,4.9,3.3,1.7,3.3,2.7-.8,1.5-2.1,1.5a7.3,7.3,0,0,1-3.8-1.1.7.7,0,0,0-1,.1h0l-.7,1.4a.6.6,0,0,0,.2.8,9.3,9.3,0,0,0,5.1,1.6c3.5,0,5.5-2.1,5.5-4.5S160.5,16,157.7,14.8Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9,8.2a8.2,8.2,0,0,0-4.5,1.6V3.1a.8.8,0,0,0-.7-.8H56.8a.8.8,0,0,0-.7.8V23.3a.7.7,0,0,0,.7.7h1.9a.6.6,0,0,0,.7-.6h0V13.7a4.7,4.7,0,0,1,4.1-2.3c2,0,3,1.5,3,4.1v7.8a.8.8,0,0,0,.8.7h1.9a.7.7,0,0,0,.7-.7V15.5C69.9,11.3,68.3,8.2,63.9,8.2Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,19.2a.8.8,0,0,0-1,.1h0a4.5,4.5,0,0,1-3.6,1.9,4.6,4.6,0,0,1-4.6-4.8h0a4.7,4.7,0,0,1,4.5-4.9h.2A4.3,4.3,0,0,1,99.6,13c.3.2.6.5,1,.1l1.2-1.1c.4-.2.4-.7.2-1.1h0a7.2,7.2,0,0,0-5.6-2.7,8.1,8.1,0,0,0-8,8.1,7.9,7.9,0,0,0,7.7,8.1h.2a7.2,7.2,0,0,0,6-3.2.8.8,0,0,0-.2-1.1Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6,19.2a.8.8,0,0,0-1,.1h-.1a4.4,4.4,0,0,1-3.6,1.9,4.7,4.7,0,0,1-4.6-4.8h0a4.8,4.8,0,0,1,4.6-4.9H48A4.5,4.5,0,0,1,51.2,13a.6.6,0,0,0,1,.1L53.4,12a.8.8,0,0,0,.1-1.1h0a7.1,7.1,0,0,0-5.6-2.7A8,8,0,0,0,40,16.3a7.9,7.9,0,0,0,7.7,8.1h.2a7.2,7.2,0,0,0,6-3.2c.3-.4.1-.8-.3-1.1Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.5,8.2a7.1,7.1,0,0,0-5.2,2.2L137.8,9c-.1-.3-.3-.5-.6-.4h-.8a.8.8,0,0,0-.8.7v14a.8.8,0,0,0,.8.7h1.7c.6,0,.9-.2.9-.7V13.7a4.5,4.5,0,0,1,4.1-2.3c2,0,3,1.5,3,4v7.9a.7.7,0,0,0,.7.7h1.9a.8.8,0,0,0,.8-.7V15.5C149.4,11.5,148.2,8.2,143.5,8.2Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.5,8.6h-1.8a.8.8,0,0,0-.8.7v14a.7.7,0,0,0,.8.7h1.8a.8.8,0,0,0,.8-.7V9.3A.8.8,0,0,0,131.5,8.6Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.6,1.6a2.2,2.2,0,0,0-2.2,2.2h0a2.2,2.2,0,0,0,2.2,2.2h0a2.2,2.2,0,0,0,2.3-2.2,2.3,2.3,0,0,0-2.2-2.3Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.4,15.5l6.2-5.9a.5.5,0,0,0,.1-.8c-.1-.2-.3-.2-.5-.2h-2.4a1.8,1.8,0,0,0-1,.4l-5.9,5.4V3.1c0-.4-.4-.7-.8-.8h-1.8c-.4,0-.7.4-.8.8V23.3a.8.8,0,0,0,.8.7h1.8a.8.8,0,0,0,.8-.7V16.5l6.2,7.2a.8.8,0,0,0,.7.3h2.7a.6.6,0,0,0,.5-1Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.2,14.5h-6.3c-.4-.1-.6.2-.7.6h0v1.4a.7.7,0,0,0,.7.6h6.3c.4,0,.7-.2.7-.6h0V15.1a.6.6,0,0,0-.6-.6Z",
    fill: "#444"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,16c0,12.4-3.1,15.5-15.5,15.5S.5,28.4.5,16,3.6.5,16,.5,31.5,3.6,31.5,16Z",
    fill: "url(#linear-gradient--check-ins)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2,13.3l-8,8a1.9,1.9,0,0,1-2.6,0h0L8.8,17.4a1.8,1.8,0,0,1,0-2.5,1.9,1.9,0,0,1,2.6,0h0l2.5,2.5,6.7-6.7a1.9,1.9,0,0,1,2.6,0,1.8,1.8,0,0,1,0,2.5Z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckInsBadgeColor);
export default __webpack_public_path__ + "static/media/check-ins-badge-color.776137fe87cb12b3add43a62bf97f7e8.svg";
export { ForwardRef as ReactComponent };